// extracted by mini-css-extract-plugin
export var active = "_i2-7";
export var blink = "_i2-8";
export var dropDownSelector = "_i2-4";
export var dropDownWrapper = "_i2-3";
export var fakeCursor = "_i2-6";
export var fontSizeButton = "_i2-9";
export var formQuillEditor = "_i2-0";
export var pressed = "_i2-a";
export var qlBlank = "_i2-1";
export var textFormattingToolbar = "_i2-2";
export var textToolbarOption = "_i2-5";